/** Sales' read of how likely this lead is to book. Hidden by the caller until a score exists. */
export default function LeadScoreThermometer({ score }: { score: number }) {
  const value = Math.max(0, Math.min(100, Math.round(score)));
  const fill = value >= 70 ? 'bg-rose-500' : value >= 40 ? 'bg-amber-400' : 'bg-sky-400';
  return (
    <span className="inline-flex items-center gap-1.5" title={`Lead score ${value}`}>
      <span className="relative h-1.5 w-10 overflow-hidden rounded-full bg-gray-200" aria-hidden>
        <span className={`absolute inset-y-0 left-0 rounded-full ${fill}`} style={{ width: `${Math.max(value, 6)}%` }} />
      </span>
      <span className="text-[11px] font-semibold tabular-nums text-gray-700">{value}</span>
    </span>
  );
}
